module.exports = __webpack_public_path__ + "img/890-73013d.png";